import { Action, createReducer, on } from '@ngrx/store';
import { StateBuilder } from '../../../model/state.builder';
import { AuthActions } from './auth.actions';
import { IAuthGuideState, IAuthLoginState, IAuthOtpState } from './auth.state';

/**
 * auth guide
 */

export const initialAuthGuideState: IAuthGuideState = {
  model: undefined,
  data: undefined
};

const authGuideReducerFn = createReducer(
  initialAuthGuideState,
  on(AuthActions.resetGuide, (state: IAuthGuideState, action) => {
    return new StateBuilder<IAuthGuideState>(initialAuthGuideState).build();
  }),
  on(AuthActions.loadGuide, (state: IAuthGuideState, action) => {
    return new StateBuilder<IAuthGuideState>(state).toLoading().build();
  }),
  on(AuthActions.loadGuideSuccess, (state: IAuthGuideState, action) => {
    return new StateBuilder<IAuthGuideState>(state).toLoaded().build();
  }),
  on(AuthActions.submitGuide, (state: IAuthGuideState, action) => {
    return new StateBuilder<IAuthGuideState>(state).toLoading().build();
  }),
  on(AuthActions.submitGuideSuccess, (state: IAuthGuideState, action) => {
    return new StateBuilder<IAuthGuideState>(state).toLoaded().build();
  })
);

export function authGuideReducer(state: IAuthGuideState | undefined, action: Action) {
  return authGuideReducerFn(state, action);
}

/**
 * auth otp
 */

export const initialAuthOtpState: IAuthOtpState = {
  model: undefined,
  data: undefined,
  otpSendAttemptsCount: 0
};

const authOtpReducerFn = createReducer(
  initialAuthOtpState,
  on(AuthActions.resetOtp, (state: IAuthOtpState, action) => {
    return new StateBuilder<IAuthOtpState>(initialAuthOtpState).build();
  }),
  on(AuthActions.updateOtpModel, (state: IAuthGuideState, action) => {
    return new StateBuilder<IAuthGuideState>(state, action).build();
  }),
  on(AuthActions.incOtpSendAttemptCount, (state: IAuthOtpState, action) => {
    let { otpSendAttemptsCount: loginAttemptCount } = state;
    loginAttemptCount++;
    return new StateBuilder<IAuthOtpState>(state, { otpSendAttemptsCount: loginAttemptCount }).build();
  }),
  on(AuthActions.loadOtp, (state: IAuthOtpState, action) => {
    return new StateBuilder<IAuthOtpState>(state).toLoading().build();
  }),
  on(AuthActions.loadOtpSuccess, (state: IAuthOtpState, action) => {
    return new StateBuilder<IAuthOtpState>(state, action).toLoaded().build();
  }),
  on(AuthActions.submitOtp, (state: IAuthOtpState, action) => {
    return new StateBuilder<IAuthOtpState>(state, action).toLoading().build();
  }),
  on(AuthActions.submitOtpSuccess, (state: IAuthOtpState, action) => {
    return new StateBuilder<IAuthOtpState>(state, action).toLoaded().build();
  })
);

export function authOtpReducer(state: IAuthOtpState | undefined, action: Action) {
  return authOtpReducerFn(state, action);
}

/**
 * auth login
 */

export const initialAuthLoginState: IAuthLoginState = {
  model: undefined,
  data: undefined
};

const authLoginReducerFn = createReducer(
  initialAuthLoginState,
  on(AuthActions.resetLogin, (state: IAuthLoginState, action) => {
    return new StateBuilder<IAuthLoginState>(initialAuthLoginState).build();
  }),
  on(AuthActions.loadLogin, (state: IAuthLoginState, action) => {
    return new StateBuilder<IAuthLoginState>(state).toLoading().build();
  }),
  on(AuthActions.loadLoginSuccess, (state: IAuthLoginState, action) => {
    return new StateBuilder<IAuthLoginState>(state, action).toLoaded().build();
  }),
  on(AuthActions.submitLogin, (state: IAuthLoginState, action) => {
    return new StateBuilder<IAuthLoginState>(state, action).toLoading().build();
  }),
  on(AuthActions.submitLoginSuccess, (state: IAuthLoginState, action) => {
    return new StateBuilder<IAuthLoginState>(state, action).toLoaded().build();
  })
);

export function authLoginReducer(state: IAuthLoginState | undefined, action: Action) {
  return authLoginReducerFn(state, action);
}
